/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';

export interface IAdressAlert {
    message?: string;
}

/**
 * Address alert.
 * @param props - Configuration of the functional component.
 * @returns React functional component.
 */
export const AddressAlertFunctionComponent: React.FC<IAdressAlert> = (props: IAdressAlert) => {
    const message = props.message;
    return (
        <span className='msc-address-form__alert' role='alert' aria-live='assertive'>
            {message && <>{message}</>}
        </span>
    );
};

export default AddressAlertFunctionComponent;
